import { IoMdUndo, IoMdRedo } from "react-icons/io";
import {
  MdLocalPrintshop,
  MdSpellcheck,
  MdFormatColorText,
  MdFormatListBulleted,
  MdInsertLink,
  MdFormatLineSpacing,
  MdChecklist,
  MdFormatListNumbered,
  MdFormatIndentDecrease,
  MdOutlineFormatClear,
  MdFormatIndentIncrease,
} from "react-icons/md";
import {
  AiFillFormatPainter,
  AiOutlineAlignLeft,
  AiOutlineAlignRight,
} from "react-icons/ai";
import { BsTypeBold, BsTypeUnderline, BsTextCenter } from "react-icons/bs";
import { BiItalic, BiCommentAdd, BiImageAlt } from "react-icons/bi";
import { FiAlignJustify } from "react-icons/fi";
import { FaHighlighter } from "react-icons/fa";
export const option1 = [
  <IoMdUndo />,
  <IoMdRedo />,
  <MdLocalPrintshop />,
  <MdSpellcheck />,
  <AiFillFormatPainter />,
  "|",
  <BsTypeBold />,
  <BiItalic />,
  <BsTypeUnderline />,
  <MdFormatColorText />,
  <FaHighlighter />,
  "|",
  <MdInsertLink />,
  <BiCommentAdd />,
  <BiImageAlt />,
  "|",
  <AiOutlineAlignLeft />,
  <BsTextCenter />,
  <AiOutlineAlignRight />,
  <FiAlignJustify />,
  "|",
  <MdFormatLineSpacing />,
  "|",
  <MdChecklist />,
  <MdFormatListBulleted />,
  <MdFormatListNumbered />,
  <MdFormatIndentDecrease />,
  <MdFormatIndentIncrease />,
  "|",
  <MdOutlineFormatClear />,
];
